import { render, staticRenderFns } from "./rendanDetail.vue?vue&type=template&id=0737dc29&scoped=true&"
import script from "./rendanDetail.vue?vue&type=script&lang=js&"
export * from "./rendanDetail.vue?vue&type=script&lang=js&"
import style0 from "./rendanDetail.vue?vue&type=style&index=0&id=0737dc29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0737dc29",
  null
  
)

export default component.exports